import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useState } from 'react'
import { useStore } from '~/state/useStore'
import { useRouteStateHygiene } from '~/state/useRouteStateHygiene'
import { AdvisorMount } from '~/advisor'
import { TopBar } from './TopBar'
import { AppDrawer } from './AppDrawer'
import { Footer } from './Footer'

export function AppLayout() {
  useRouteStateHygiene()
  const { isLoading, isAuthenticated } = useAuth0()
  const user = useStore((s) => s.auth.user)
  const [open, setOpen] = useState(false)

  // Render bare <Outlet /> until auth is resolved. Avoids brief chrome flash on
  // logout / unauthenticated redirect; PrivateRoute on the inner route does the
  // actual redirect.
  if (isLoading || !isAuthenticated || !user) return <Outlet />

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* TopBar consumes only `email` directly — AdminBadge reads role from the store independently (locked: see spec §E). */}
      <TopBar user={{ email: user.email }} drawerOpen={open} onToggle={() => setOpen((o) => !o)} />
      <AppDrawer open={open} />
      <AdvisorMount />
      <Box component="main" sx={{ flex: 1, mt: '64px', minWidth: 0 }}>
        <Outlet />
        <Footer />
      </Box>
    </Box>
  )
}
